import { ImgHTMLAttributes, useState } from 'react';

import { TPairingWarrior } from '~/../api/common.types';
import { generatePairingImages } from '~/utils/utils';

interface Props extends ImgHTMLAttributes<any> {
  fallback: string;
}

function ImageWithFallback({ fallback, src, ...props }: Props) {
  const [imgSrc, setImgSrc] = useState<string | undefined>(src);
  const onError = () => setImgSrc(fallback);
  return (
    <img
      src={imgSrc ? imgSrc : fallback}
      alt={props.alt}
      onError={onError}
      {...props}
    />
  );
}

export default function MatchupWarrior({
  facing,
  warrior,
  active,
  stunned,
}: {
  facing: string;
  warrior: TPairingWarrior;
  active: boolean;
  stunned?: boolean;
}) {
  const images = generatePairingImages(warrior);
  const characterKey = warrior.character.toLowerCase().replace(' ', '-');

  return (
    <div
      className={`warrior__details warrior__details--${facing}  warrior__details--${characterKey}
      warrior__active--${active} warrior__level-${warrior.level}${stunned? ' warrior__details--stunned' : ''}`}
    >
      <ImageWithFallback
        fallback="/img/transparent.png"
        src={stunned ? images.stunned : images.active}
        alt={warrior.name}
        loading="lazy"
        className={`warrior__image warrior__image--active warrior__image--${facing} warrior__image--${characterKey}`}
      />
      <ImageWithFallback
        fallback="/img/transparent.png"
        src={stunned ? images.stunned : images.notActive}
        alt={warrior.name}
        loading="lazy"
        className={`warrior__image warrior__image--not-active warrior__image--${facing} warrior__image--${characterKey}`}
      />
    </div>
  );
}
